import { useState, useEffect } from 'react';
import baseCopy from './tnc/us';

const useRules = (locale: string): { rules: string[] } => {
    const [rules, setRules] = useState<string[]>([]);

    useEffect(() => {
        (async () => {
            try {
                const module = await import(`./tnc/${locale}.ts`);
                setRules(module.default || []);
            } catch (error) {
                console.error(`Failed to load ${locale}`, error);
                setRules(baseCopy);
            }
        })();
    }, [locale]);

    return { rules };
};

export default useRules;
